import Joi from '@hapi/joi'

export const DivisionSummaryReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    divisionID: Joi.number().label("Division").messages({
        "any.invalid": `Select Collection Point`,
        "any.required": `Collection Point required`
    }),

    fieldID: Joi.number().label("Field").messages({}),
    
    searchDate: Joi.string().invalid("").required().label("Search Date").messages({
        "any.required": `Date required`
    }),

    categoryID: Joi.number().label("Category").messages({}),
}